import React, { useState } from 'react';
import { FormattedMessage } from "react-intl";
import PayoutDistributionTable from "../../components/PayoutDistributionTable/PayoutDistributionTable";
import Pick12PayoutCalculator from "../../services/Pick12ParlayPayoutCalculator";
import Pick16PayoutCalculator from "../../services/Pick16ParlayPayoutCalculator";
import GlobalConst from "../../constants/GlobalConst";

import './FAQView.style.scss';
import {formatRichText} from "../../utils/I18nUtils";
const FAQView = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const tr = "help.faq";
    const faqs = [
        { questionId: `${tr}.q1`, answerId: `${tr}.a1` },
        { questionId: `${tr}.q2`, answerId: `${tr}.a2` },
        { questionId: `${tr}.q3`, answerId: `${tr}.a3` },
        { questionId: `${tr}.q4`, answerId: `${tr}.a4` },
        { questionId: `${tr}.q5`, answerId: `${tr}.a5` },
        { questionId: `${tr}.q6`, answerId: `${tr}.a6` },
        { questionId: `${tr}.q7`, answerId: `${tr}.a7` },
        { questionId: `${tr}.q8`, answerId: `${tr}.a8` },
        { questionId: `${tr}.q9`, answerId: `${tr}.a9` },
        { questionId: `${tr}.q10`, answerId: `${tr}.a10`, component: <PayoutDistributionTable payoutInfos={new Pick12PayoutCalculator().calculateDistribution(5)} currency={GlobalConst.SITE_CURRENCY} showProgressive/> },
        { questionId: `${tr}.q11`, answerId: `${tr}.a11`, component: <PayoutDistributionTable payoutInfos={new Pick16PayoutCalculator().calculateDistribution(5, 0)} currency={GlobalConst.SITE_CURRENCY} showProgressive /> },
        { questionId: `${tr}.q12`, answerId: `${tr}.a12` },
        { questionId: `${tr}.q13`, answerId: `${tr}.a13` },
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="FAQView">
            <h1>
                <FormattedMessage id="help.faq.title" />
            </h1>
            <div className="faq-list">
                {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <div className={`faq-question ${openIndex === index ? 'opened' : ''}`} onClick={() => toggleFAQ(index)}>
                            <FormattedMessage id={faq.questionId}
                                              values={formatRichText} />
                            <span className="arrow">
                                <i className={`fa-solid ${openIndex === index ? 'fa-angle-down' : 'fa-angle-right'}`} />
                            </span>
                        </div>
                        {openIndex === index && (
                            <div className="faq-answer">
                                <p><FormattedMessage id={faq.answerId}
                                                     values={formatRichText} /></p>
                                {faq.component && faq.component}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQView;
